import React from "react";

export default function CSS_InterviewPrep() {
  return (
    <div className="tutorial-page">
      <h1>CSS InterviewPrep</h1>
      <p>This is the CSS InterviewPrep tutorial page.</p>
    </div>
  );
}
